import React, { useState, useEffect } from 'react';

const EditStageModal = ({ item, onClose, onSave }) => {
    const [name, setName] = useState('');
    const [section, setSection] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (item) {
            setName(item.name || '');
            setSection(item.section || '');
        }
    }, [item]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await onSave(item.id, item.type, { name, section });
            onClose();
        } catch (error) {
            console.error('Update failed:', error);
            alert('Failed to update: ' + error.message);
        } finally {
            setLoading(false);
        }
    };

    if (!item) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <div className="modal-header">
                    <h3>Edit {item.type === 'stage' ? 'Stage' : 'Road'}</h3>
                    <button className="close-btn" onClick={onClose}>&times;</button>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Name</label>
                        <input
                            type="text"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                        />
                    </div>

                    {item.type === 'stage' && (
                        <div className="form-group">
                            <label>Section</label>
                            <input
                                type="text"
                                value={section}
                                onChange={(e) => setSection(e.target.value)}
                            />
                            <small className="help-text">e.g., LEG 1, LEG 2</small>
                        </div>
                    )}

                    <div className="modal-actions">
                        <button type="button" className="btn btn-secondary" onClick={onClose} disabled={loading}>
                            Cancel
                        </button>
                        <button type="submit" className="btn btn-primary" disabled={loading}>
                            {loading ? 'Saving...' : 'Save Changes'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EditStageModal;
